import Swiper from 'swiper';
import {Navigation, Pagination, FreeMode, A11y, Autoplay} from 'swiper/modules';
const $ = window.jQuery;


const $DOM = {};
let imageSwiper;

const domCache = () => {
    $DOM.container = $(".image-links-carousel");
    if(!$DOM.container.length) {
        return;
    }
    $DOM.swiperContainer = $DOM.container.find(".image-links-carousel-swiper-container");
}

const initSwiper = () => {
    imageSwiper = new Swiper($DOM.swiperContainer[0], {
        modules: [Navigation, Pagination, FreeMode, A11y, Autoplay],
        init: false,
        slidesPerView: 1.5,
        speed: 500,
        spaceBetween: 16,
        preventClicksPropagation: false,
        roundLengths: true,
        freeMode: true,
        // freeModeMomentumBounce: false,
        // freeModeMomentumRatio: .1,
        // freeModeMomentumVelocityRatio: .8,
        // freeModeSticky: true,
        // grabCursor: true,
        // loop: false,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            waitForTransition: false,
        },
        a11y: true,
        watchOverflow: true,
        breakpoints: {
            640: {
                slidesPerView: 2.5
            },
            768 : {
                slidesPerView: 3.5
            },
            1024 : {
                slidesPerView: 5
            }
        }
    });

    imageSwiper.on("init", onInit);
    imageSwiper.on("slideChange", onSlideChange);
    imageSwiper.init();
}

const onInit = () => {
    $DOM.swiperContainer.addClass("is-init");
}

const onSlideChange = () => {

}




const imageLinksCarousel = {
    init: () => {
        domCache();
        if(!$DOM.container.length) {
            return;
        }
        initSwiper();
    }
};

export default imageLinksCarousel;
